module.exports = "<!--<app-login-page></app-login-page>-->\n<app-front-page></app-front-page>"